import { IAvailablePermissions } from '../types';
import { useAppSelector } from './useRedux';

export const usePermissions = () => {
  const permissions = useAppSelector((state) => state.user.permissions);

  const hasPermissions = (perms: IAvailablePermissions[]) => {
    if (!permissions) {
      return false;
    }
    for (let i = 0; i < perms.length; i++) {
      const hasPermission = permissions[perms[i]];
      if (!hasPermission) {
        return false;
      }
    }
    return true;
  };

  const getRole = () => {
    if (!permissions) {
      return false;
    }
    return permissions.role;
  };
  return { hasPermissions, getRole };
};
